import { SKU_CATEGORY } from '../PaymentProvider.d';

const getProductImageUrl = ({
  SKUCategory,
  coverImageUrl,
  skuCode,
  defaultProductImageUrl,
  paymentConfig,
}: {
  SKUCategory: SKU_CATEGORY;
  coverImageUrl: string;
  skuCode?: string;
  defaultProductImageUrl: string;
  paymentConfig: {
    customBundleSKUPrefix: string;
    customBundleProductImageUrl: string;
  };
}) => {
  if (SKUCategory === SKU_CATEGORY.WORKSHOP_BATCH) {
    return coverImageUrl;
  }

  if (
    SKUCategory === SKU_CATEGORY.COLLECTION &&
    paymentConfig?.customBundleSKUPrefix &&
    skuCode?.startsWith(paymentConfig?.customBundleSKUPrefix)
  ) {
    return paymentConfig?.customBundleProductImageUrl ?? undefined;
  }

  return defaultProductImageUrl;
};

export default getProductImageUrl;
